import { PropagateLoader } from 'react-spinners';

function Loader({ loading }) {
  return (
    <div className="flex flex-col items-center justify-center gap-4 min-h-dvh">
      <PropagateLoader
        color="rgba(255, 165, 0, 0.5)"
        loading={loading}
        size={15}
      />
    </div>
  );
}

export default Loader;
